import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ApiRoutes {
    public static Api = 'api';
    public static AcceptBackupCodes = 'acceptBackupCodes';
    public static AuthenticateUser = 'authenticateUser';
    public static CheckBackupCodes = 'checkBackupCodesAccepted';
    public static CreateOrUpdateUserState = 'createOrUpdateUserState';
    public static CreateTotpMfaToken = 'createTotpMfaToken';
    public static Endpoints = 'endpoints';
    public static GetApiTokens = 'getApiTokens';
    public static GetCurrentUser = 'getCurrentUser';
    public static GetFeatureFlags = 'getFeatureFlags';
    public static GetLogs = 'getLogs';
    public static GetUserState = 'getUserState';
    public static GenerateBackupCodes = 'generateBackupCodes';
    public static ListUserStates = 'listUserStates';
    public static ListNotifications = 'listNotifications';
    public static AcknowledgeNotification = 'acknowledgeNotificationState';
    public static BatchAcknowledgeNotification = 'batchAcknowledgeNotificationState';
    public static ValidateEmailAddressVerificationCode = 'validateVerificationCode';
    public static ValidatePhoneNumberVerificationCode = 'validatePhoneNumberVerificationCode';
    public static ValidateUserForgotPasswordCode = 'validateUserForgotPasswordCode';
    public static SendEmailAddressVerificationCode = 'sendEmailAddressVerificationCode';
    public static SendPhoneNumberVerificationCode = 'sendPhoneNumberVerificationCode';
    public static VerifyTotpMfaToken = 'verifyTotpMfaToken';
    public static Health = '_healthz';
    public static Logout = 'logout';
    public static Timeout = 'sessionTimeout';
    public static PageClosed = 'pageClosed';
    public static Logs = 'logs';
    public static SelectCompany = 'selectCompany';
    public static WebSockets = 'ws';
}
